// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"406":"2e58b43f","453":"1bd3181f","767":"17040778"}[chunkId] + ".chunk.js";
};